import angular from 'angular';
import * as Configuration from 'src/ajs-app/app.constants.js';

const moduleName = 'tasks.services';


/**
 * @ngdoc TasksService
 * @name TasksService
 * @description :  Service export class that deals with all the tasks list actions
 *
 *
 */

export class TasksService {
  constructor($http, UserFactory, StrategiesFactory, PreferencesFactory, $translate, $filter, $rootScope, AsyncRequestFactory, $state) {
    this.$http = $http;
    this.UserFactory = UserFactory;
    this.StrategiesFactory = StrategiesFactory;
    this.PreferencesFactory = PreferencesFactory;
    this.$translate = $translate;
    this.$filter = $filter;
    this.$rootScope = $rootScope;
    this.counters = [];
    this._AsyncRequestFactory = AsyncRequestFactory;
    this.$state = $state;
  }

  // TODO not to delete
  // try to focus the right side, so that page-up and page-down keys do scroll
  focusDummyButton(cssClass, delay) {
    window.setTimeout(() => {
      const dummyButton = angular.element('.dummy-button-for-focus.' + cssClass)[0];
      if (dummyButton) {
        dummyButton.focus({ preventScroll: true });
      }
    }, delay); // wait for DOM rendering, though
  }

  // Called by both the ajs and angular code
  backToTasksList(queueId) {
    // async callback, the user can have changed page before this call, leading to an error
    if(this.$state.includes('**.process')) {
      if (queueId) {
        this.$state.go('^', { queueId });
      } else {
        this.$state.go('^');
      }
    }
  }

  // TODO migrate
  // Called by the angular app 
  acquireCurrentTaskAndReloadState() {
    this.$state.go('.', { acquire: 'any' }, { reload: true });
  }


  static TasksFactory($http, UserFactory, StrategiesFactory, PreferencesFactory, $translate, $filter, $rootScope, AsyncRequestFactory, $state) {
    return new TasksService($http, UserFactory, StrategiesFactory, PreferencesFactory, $translate, $filter, $rootScope, AsyncRequestFactory, $state);
  }
}
TasksService.TasksFactory.$inject = ['$http', 'UserFactory', 'StrategiesFactory', 'PreferencesFactory', '$translate', '$filter', '$rootScope', 'AsyncRequestFactory', '$state'];


/**
 * @deprecated use angular version 
 * @ngdoc TaskActionsService
 * @name TaskActionsService
 * @description :  Service export class that deals with all task actions
 *
 */
export class TaskActionsService {
  constructor($http, AsyncRequestFactory) {
    this.$http = $http;
    this.AsyncRequestFactory = AsyncRequestFactory;
  }

  /**
   * @deprecated
   * migrated in task-actions.service.ts
   * not to delete, used in task-and-message-actions-menu.directive.js
   */
  assign(companyId, taskId, taskState, data) {
    return this.$http.post(Configuration.constants.baseUrl + companyId + '/task/' + taskId + '/acquire/' + taskState, data);
  }

  /**
   * @deprecated
   * migrated in task-actions.service.ts
   * not to delete, used in task-and-message-actions-menu.directive.js
   */
  archive(companyId, taskId, data) {
    return this.$http.post(Configuration.constants.baseUrl + companyId + '/task/' + taskId + '/archive', data);
  }


  static TaskActionsFactory($http, AsyncRequestFactory) {
    return new TaskActionsService($http, AsyncRequestFactory);
  }
}
TaskActionsService.TaskActionsFactory.$inject = ['$http', 'AsyncRequestFactory'];

angular
  .module(moduleName, [])
  .factory('TasksFactory', TasksService.TasksFactory)
  .factory('TaskActionsFactory', TaskActionsService.TaskActionsFactory)
  ;
